module.exports = __webpack_public_path__ + "static/MTDC-3e63e77bba50860206c3fcbc67202717.png";